<template>
  <ion-page>
    <ion-content fullscreen />
    <ion-footer class="ion-padding footer-onboarding">
      <h1>
        {{ $t('login.email') }}
      </h1>
      <p class="ion-margin-bottom">
        {{ $t('login.email_description') }}
      </p>
      <ion-input
        v-model="email"
        type="email"
        :placeholder="$t('login.your_email')"
      />
      <ion-button
        expand="block"
        @click="loginLink"
      >
        {{ $t('login.send_link') }}
      </ion-button>
      <ion-button
        fill="clear"
        expand="block"
        color="medium"
        class="ion-no-margin"
        @click="back"
      >
        {{ $t('general.back') }}
      </ion-button>
    </ion-footer>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import {
  IonFooter,
  IonInput,
  modalController,
  loadingController,
} from '@ionic/vue';
import LoginLink from '@/components/LoginLink.vue';
import Login from '@/components/Login.vue';
import UserService from '@/services/User';

export default defineComponent({
  components: {
    IonFooter,
    IonInput,
  },
  data() {
    return {
      email: null,
    };
  },
  methods: {
    /**
     * Log in with link.
     */
    async loginLink() {
      const loading = await loadingController.create({
        message: this.$t('general.loading'),
      });
      await loading.present();
      await UserService.requestLink(this.email);
      await loading.dismiss();

      await modalController.dismiss();

      const modal = await modalController.create({
        component: LoginLink,
        showBackdrop: false,
        backdropDismiss: false,
      });
      await modal.present();
    },
    /**
     * Go back to login.
     */
    async back() {
      await modalController.dismiss();

      const modal = await modalController.create({
        component: Login,
        showBackdrop: false,
        backdropDismiss: false,
      });
      await modal.present();
    },
  },
});
</script>

<style scoped>
ion-content {
  --background: none;
}
</style>
